import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useQueryClient } from 'react-query';
import { getCrmBrandLocationsEndpointIdentifier } from './use-get-crm-brand-locations-api';

const endpoint = 'ums/v1/crm/management/brands/locations';
export const deleteCrmBrandLocationEndpointIdentifier = endpoint;

type TData = Record<string, any>;
type TError = AxiosError<{ message: string }>;
type Options = UseMutationOptions<TData, TError, number>;
type ReturnType = UseMutationResult<TData, TError, number>;

export function useDeleteCrmBrandLocationApi(options?: Options): ReturnType {
  const toast = useCustomToast();
  const queryClient = useQueryClient();

  const mutationFn = async (id: number) => {
    try {
      const response = await http.delete(`${endpoint}/${id}`);

      toast({
        description: 'Brand location deleted successfully',
        status: 'success',
      });

      return response.data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  const { ...otherOptions } = options || {};

  return useMutationWrapper(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries([getCrmBrandLocationsEndpointIdentifier]);
    },
    ...otherOptions,
  });
}
